<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" style="padding: 0px 10px">
      <div class="coreMain statistics">
        <el-row class="coreMainRow">
          <el-row :gutter="25">
            <el-col :span="15">
              <div class="dashboardCard" style="height:100%">
                <div class="title">
                  <span>设备监测展示</span>
                </div>
                <el-divider></el-divider>
                <div class="cardContainer">
                  <div class="dashboardMap">
                    <baidu-map style="width: 100%;height: 100%" @ready="handler" :center="center" :zoom="8"
                      :scroll-wheel-zoom="true">
                      <bml-marker-clusterer :averageCenter="true">
                        <bm-marker v-for="(marker,i) in markers" :position="marker.position" @click="marker.show = true"
                          :title="marker.name" :key="i">
                          <bm-info-window :show="marker.show" @close="marker.show = false" @open="marker.show = true">
                            <div class="bm_info">
                              <p :title="marker.onlineStatus==1?'在线中':'已离线'"
                                style="display: -webkit-flex;-webkit-align-items: center;display: flex;align-items: center">
                                <span
                                  style="max-width:85%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">设备名称:{{marker.name}}</span>
                                <span class="onOffLine" :class="marker.onlineStatus==1?'online':'offline'"></span>
                              </p>
                              <p>设备编号:{{marker.code}}</p>
                              <p>所在位置:{{marker.location}}</p>
                            </div>
                          </bm-info-window>
                        </bm-marker>
                      </bml-marker-clusterer>
                    </baidu-map>
                  </div>
                </div>

              </div>
            </el-col>
            <el-col :span="9" style="margin-bottom: 0px;">
              <el-row>
                <el-col :span="24">
                  <div class="dashboardCard">
                    <div class="title">
                      <span>设备状态统计</span>
                      <i class="el-icon-refresh echartTime" title="刷新" @click="getDevCount"></i>
                    </div>
                    <el-divider></el-divider>
                    <div class="cardContainer" style="height: 180px">
                      <el-col :span="13" style="padding-left:5%;">
                        <div class="count">
                          <span
                            style="color:#409EFF;">{{formatCount(devCount.online)}}</span><span>/</span><span>{{formatCount(devCount.online+devCount.offline)}}</span>
                          个
                        </div>
                        <div style="margin-bottom: 16px">
                          <i class="cubes" style="background:#409EFF;"></i>
                          <span>在线:{{devCount.online}}个</span>
                        </div>
                        <div>
                          <i class="cubes" style="background:rgba(151,151,151,0.28);"></i>
                          <span>离线:{{devCount.offline}}个</span>
                        </div>
                      </el-col>
                      <el-col :span="11">
                        <el-progress type="circle" :width="140" :stroke-width="15" :percentage="devCountPercentage">
                        </el-progress>
                      </el-col>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="dashboardCard">
                    <div class="title">
                      <span>网关状态统计</span>
                      <i class="el-icon-refresh echartTime" title="刷新" @click="getModCount"></i>
                    </div>
                    <el-divider></el-divider>
                    <div class="cardContainer" style="height: 180px">
                      <el-col :span="13" style="padding-left:5%;">
                        <div class="count">
                          <span
                            style="color:#EF8C9D;">{{formatCount(modCount.online)}}</span><span>/</span><span>{{formatCount(modCount.online+modCount.offline)}}</span>
                          个
                        </div>
                        <div style="margin-bottom: 16px">
                          <i class="cubes" style="background:#EF8C9D;"></i>
                          <span>在线:{{modCount.online}}个</span>
                        </div>
                        <div>
                          <i class="cubes" style="background:rgba(151,151,151,0.28);"></i>
                          <span>离线:{{modCount.offline}}个</span>
                        </div>
                      </el-col>
                      <el-col :span="11">
                        <el-progress type="circle" color="#EF8C9D" :width="140" :stroke-width="15"
                          :percentage="mduCountPercentage"></el-progress>
                      </el-col>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <!--api调用情况-->
            <el-col :span="12">
              <div class="dashboardCard">
                <div class="title">
                  <span>api开放接口调用情况</span>
                  <span class="echartTime">
                    <el-radio-group fill="#79BBFF" style="margin-right: 10px;" v-model="statisticalType"
                      @change="apiVisitStatisticsEchart">
                      <el-radio-button label="number">调用次数</el-radio-button>
                      <el-radio-button label="consuming">调用耗时</el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-model="apiVisitStatisticsDate" @change="queryApiVisitStatistics">
                      <el-radio-button label="week">最近一周</el-radio-button>
                      <el-radio-button label="month">最近一月</el-radio-button>
                    </el-radio-group>
                  </span>
                </div>

                <el-divider></el-divider>
                <div class="cardContainer">
                  <div id="apiVisitStatistics" style="margin-top: -15px;" :style="widthChange"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dashboardCard">
                <div class="title">
                  <span>设备分类统计</span>
                </div>
                <el-divider></el-divider>
                <div class="cardContainer">
                  <div id="devCommuTypeCount" style="margin-top: -15px;" :style="widthChange"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dashboardCard">
                <div class="title">
                  <span>网关分类统计</span>
                </div>
                <el-divider></el-divider>
                <div class="cardContainer">
                  <div id="mduCommuTypeCount" style="margin-top: -15px;" :style="widthChange"></div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <!--设备在线情况-->
            <el-col :span="12">
              <div class="dashboardCard">
                <div class="title">
                  <span>设备在线情况</span>
                  <span class="echartTime">
                    <el-date-picker style="max-width:270px;margin-right: 10px" v-model="deviceDate" size="small"
                      type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      @change="changeDeviceDate">
                    </el-date-picker>
                    <el-radio-group v-model="openDeviceDate" @change="selectDeviceDate">
                      <el-radio-button label="week">最近一周</el-radio-button>
                      <el-radio-button label="month">最近一月</el-radio-button>
                    </el-radio-group>
                  </span>
                </div>

                <el-divider></el-divider>
                <div class="cardContainer">
                  <div id="deviceOnline" style="margin-top: -15px;" :style="widthChange"></div>
                </div>
              </div>
            </el-col>
            <!--网关在线情况-->
            <el-col :span="12">
              <div class="dashboardCard">
                <div class="title">
                  <span>网关在线情况</span>
                  <span class="echartTime">
                    <el-date-picker style="margin-right: 10px;max-width:270px" v-model="moduleDate" size="small"
                      type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      @change="changeModuleDate">
                    </el-date-picker>
                    <el-radio-group v-model="openModuleDate" @change="selectModuleDate">
                      <el-radio-button label="week">最近一周</el-radio-button>
                      <el-radio-button label="month">最近一月</el-radio-button>
                    </el-radio-group>
                  </span>
                </div>
                <el-divider></el-divider>
                <div class="cardContainer">
                  <div id="moduleOnline" style="margin-top: -15px;" :style="widthChange"></div>
                </div>
              </div>
            </el-col>
          </el-row>


        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  // 引入基本模板
  let echarts = require("echarts/lib/echarts");
  // 引入柱状图组件
  require("echarts/lib/chart/bar");
  // 引入折线图组件
  require("echarts/lib/chart/line");
  // 引入提示框和title组件
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  require("echarts/lib/component/legend");
  import API from "../../api/api";
  import dayjs from "dayjs";
  import {
    BmlMarkerClusterer
  } from 'vue-baidu-map'
  export default {
    components: {
      BmlMarkerClusterer
    },
    data() {
      return {
        widthChange: {
          width: "100%",
          height: "210px"
        },
        devCount: { //设备状态统计
          online: 0,
          offline: 0,
        },
        modCount: { //网关状态统计
          online: 0,
          offline: 0,
        },
        deviceDate: [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7), new Date()],
        moduleDate: [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7), new Date()],
        openDeviceDate: "week",
        openModuleDate: "week",
        deviceOnlineData: {}, //设备在线echart数据
        moduleOnlineData: {}, //网关在线echart数据
        // commuType:sessionStorage.getItem('commuType')!=0?sessionStorage.getItem('commuType'):null,
        commuType: null,
        //api调用情况
        apiVisitStatisticsDate: 'week', //接口调用筛选时间区间
        statisticalType: 'number', //展示类型 number：展示调用数，consuming：展示调用耗时
        apiVisitStatisticsData: {}, //接口调用统计数据
        deviceCommuTypeStatisticsData: {}, //设备分类统计数据
        moduleCommuTypeStatisticsData: {}, //网关分类统计数据
        //地图部分
        map: null,
        BMap: null,
        markers: [],
        center: {
          lng: 113.412085,
          lat: 23.170969
        }, //初始化默认坐标
        zoom: 5, //初始化放大倍数
      };
    },
    computed: {
      devCountPercentage() {
        var total = this.devCount.online + this.devCount.offline
        if (total > 0) {
          var percentage = (this.devCount.online / (this.devCount.online + this.devCount.offline)) * 100
          return parseFloat(percentage.toFixed(2))
        } else {
          return 0
        }
      },
      mduCountPercentage() {
        var total = this.modCount.online + this.modCount.offline
        if (total > 0) {
          var percentage = (this.modCount.online / (this.modCount.online + this.modCount.offline)) * 100
          return parseFloat(percentage.toFixed(2))
        } else {
          return 0
        }
      }
    },
    created() { },
    methods: {
      init() {
        if (this.$route.query.noGoBack) {
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
          });
        }
        this.getDevCount(); //获取设备状态统计数据
        this.getModCount(); //获取网关状态统计数据
        this.getDeviceOnlineData(); //获取设备在线状态统计数据
        this.getModuleOnlineData(); //获取网关在线状态统计数据
        this.queryDevicePosition(); //获取设备地理位置列表
        this.queryApiVisitStatistics(); //查询api调用统计数据
        this.getDeviceCommuTypeStatistics(); //查询设备分类统计
        this.getModuleCommuTypeStatistics(); //查询网关分类统计
      },
      /**
       * 地图
       * @param BMap
       * @param map
       */
      //初始化
      handler({
        BMap,
        map
      }) {
        this.BMap = BMap;
        this.map = map;
        this.center.lng = 113.412085;
        /*经度*/
        this.center.lat = 23.170969;
        /*维度*/
        this.zoom = 8;
        /*
        造成百度地图不显示港珠澳大桥的口岸
        */
        // map.setMapStyle(mapStyle);
      },
      /**********************获取设备地理位置信息**************************/
      queryDevicePosition() {
        let para = {
          commuType: this.commuType,
        };
        API.getDevicePosition(para)
          .then(res => {
            if (res.code == 1) {
              if (res.data.length > 0) {
                for (var i in res.data) {
                  var marker = res.data[i]
                  marker.show = false;

                  if (marker.longitude && marker.latitude) {
                    marker.position = {
                      lng: marker.longitude,
                      lat: marker.latitude
                    }
                  } else {
                    //如果设备没有配置位置默认显示广州市佳都大厦
                    marker.position = {
                      lng: this.center.lng,
                      lat: this.center.lat
                    }
                  }

                }
                this.markers = res.data;
              }
            } else {
              this.$message.error(res.msg);
            }
          })
      },
      /**********************获取设备状态统计数据**************************/
      getDevCount() {
        let para = {
          commuType: this.commuType,
        };
        this.devCount.online = 0
        this.devCount.offline = 0
        API.DashboardDeviceStatistics(para)
          .then(res => {
            if (res.code == 1) {
              this.devCount.online = res.data.onlineStatusNum
              this.devCount.offline = res.data.offlineStatusNum
              // this.deviceEcharts1();
            } else {
              this.$message.error(res.msg);
            }
          })
      },
      /**********************获取网关状态统计数据**************************/
      getModCount() {
        let para = {
          commuType: this.commuType,
        };
        this.modCount.online = 0
        this.modCount.offline = 0
        API.DashboardModuleStatistics(para)
          .then(res => {
            if (res.code == 1) {
              this.modCount.online = res.data.onlineStatusNum
              this.modCount.offline = res.data.offlineStatusNum
              // this.moduleEcharts2();
            } else {
              this.$message.error(res.msg);
            }
          })
      },
      /**********************获取设备下拉列表数据**************************/
      getDeviceList() {
        let para = {
          commuType: this.commuType,
        };
        API.DeviceDropdownlist(para)
          .then(res => {
            if (res.code == 1) {
              this.deviceList = res.data
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /**********************获取网关下拉列表数据**************************/
      getModuleList() {
        let para = {
          commuType: this.commuType,
        };
        API.ModuleDropdownlist(para)
          .then(res => {
            if (res.code == 1) {
              this.moduleList = res.data
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /*********************获取设备在线情况数据*************************/
      getDeviceOnlineData() {
        let para = {
          startDateStr: dayjs(this.deviceDate[0]).format("YYYY-MM-DD 00:00:00"),
          endDateStr: dayjs(this.deviceDate[1]).format("YYYY-MM-DD 23:59:59"),
          commuType: this.commuType,
        };
        API.DeviceOnlineRate(para)
          .then(res => {
            if (res.code == 1) {
              var time = [];
              var online = [];
              var offline = [];
              var onlineRate = [];
              for (let i = 0; i < res.data.length; i++) {
                time.push(res.data[i].createDateStr)
                online.push(res.data[i].deviceOnlineNum)
                offline.push(res.data[i].deviceOfflineNum)
                onlineRate.push(res.data[i].deviceOnlineRate / 100)
              }
              this.deviceOnlineData = {
                time: time,
                online: online,
                offline: offline,
                onlineRate: onlineRate,
              };
              this.deviceOnline();
            } else {
              this.$message.error(res.msg);
            }
          })

      },

      /*********************获取网关在线情况数据*************************/
      getModuleOnlineData() {
        let para = {
          startDateStr: dayjs(this.moduleDate[0]).format("YYYY-MM-DD 00:00:00"),
          endDateStr: dayjs(this.moduleDate[1]).format("YYYY-MM-DD 23:59:59"),
          commuType: this.commuType,
        };
        API.DeviceOnlineRate(para)
          .then(res => {
            if (res.code == 1) {
              var time = [];
              var online = [];
              var offline = [];
              var onlineRate = [];
              for (let i = 0; i < res.data.length; i++) {
                time.push(res.data[i].createDateStr)
                online.push(res.data[i].moduleOnlineNum)
                offline.push(res.data[i].moduleOfflineNum)
                onlineRate.push(res.data[i].moduleOnlineRate / 100)
              }
              this.moduleOnlineData = {
                time: time,
                online: online,
                offline: offline,
                onlineRate: onlineRate,
              };
              this.moduleOnline();
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      //查询api调用统计数据
      queryApiVisitStatistics() {
        var date = new Date();
        let para = {
          startTime: this.apiVisitStatisticsDate == 'month' ? dayjs(new Date(date - 30 * 24 * 3600 * 1000)).format(
            "YYYY-MM-DD") : dayjs(new Date(date - 7 * 24 * 3600 * 1000)).format("YYYY-MM-DD"),
          endTime: dayjs(new Date()).format("YYYY-MM-DD")
        };
        API.getApiVisitStatistics(para)
          .then(res => {
            if (res.code == 1) {
              var data = res.data;
              var timeLong = this.apiVisitStatisticsDate == 'month' ? 30 : 7;
              var dateList = [];
              var visitCountList = [];
              var errorCountList = [];
              var successCountList = [];
              var sumConsumeMillisecondsList = [];
              var maxConsumeMillisecondsList = [];
              var avgConsumeMillisecondsList = [];
              for (let i = timeLong; i > 0; i--) {
                var time = dayjs(new Date(date - (i - 1) * 24 * 3600 * 1000)).format("YYYY-MM-DD");
                var index = timeLong - i;
                dateList.push(time);
                visitCountList.push(0)
                errorCountList.push(0)
                successCountList.push(0)
                sumConsumeMillisecondsList.push(0)
                maxConsumeMillisecondsList.push(0)
                avgConsumeMillisecondsList.push(0)
                for (let j = 0; j < data.length; j++) {
                  if (time == data[j].date) {
                    visitCountList[index] = data[j].visitCount;
                    errorCountList[index] = data[j].errorCount;
                    successCountList[index] = data[j].visitCount - data[j].errorCount
                    sumConsumeMillisecondsList[index] = data[j].sumConsumeMilliseconds
                    maxConsumeMillisecondsList[index] = data[j].maxconsumeMilliseconds
                    avgConsumeMillisecondsList[index] = parseFloat((data[j].visitCount == 0 ? 0 : (data[j]
                      .sumConsumeMilliseconds / data[j].visitCount)).toFixed(2))
                  }
                }
              }
              this.apiVisitStatisticsData = {
                dateList: dateList,
                visitCountList: visitCountList,
                errorCountList: errorCountList,
                successCountList: successCountList,
                sumConsumeMillisecondsList: sumConsumeMillisecondsList,
                maxConsumeMillisecondsList: maxConsumeMillisecondsList,
                avgConsumeMillisecondsList: avgConsumeMillisecondsList,
              }
              this.apiVisitStatisticsEchart();
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /**
       * 设备分类统计
       */
      getDeviceCommuTypeStatistics() {
        API.deviceCommuTypeStatistics()
          .then(res => {
            if (res.code == 1) {
              this.deviceCommuTypeStatisticsData = res.data
              this.commuTypeStatisticsEchart('dev', this.deviceCommuTypeStatisticsData);
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /**
       *网关分类统计
       */
      getModuleCommuTypeStatistics() {
        API.moduleCommuTypeStatistics()
          .then(res => {
            if (res.code == 1) {
              this.moduleCommuTypeStatisticsData = res.data
              this.commuTypeStatisticsEchart('mdu', this.moduleCommuTypeStatisticsData);
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      //统计数字格式转换
      formatCount(val) {
        var returnCount = val;
        if (val >= 1000000000000) {
          returnCount = parseInt(val / 1000000000) + 'B+';
        } else if (val >= 100000000) {
          returnCount = parseInt(val / 1000000) + 'M+';
        } else if (val >= 100000) {
          returnCount = parseInt(val / 1000) + 'K+';
        }
        return returnCount;
      },

      /**设备在线情况echart图*****/
      deviceOnline() {
        // 基于准备好的dom，初始化echarts实例
        let deviceOnline = echarts.init(document.getElementById("deviceOnline"));
        deviceOnline.clear();
        var data = this.deviceOnlineData;
        deviceOnline.setOption({
          color: ["#D8D8D8", "#5BAD23"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: ["在线", "离线"],
            x: "60px"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: data.time
          },
          yAxis: [{
            name: '设备数(台)',
            type: 'value',
          },
          {
            name: '在线率(%)',
            max: 100,
            type: 'value',
          }
          ],
          series: [{
            name: "离线(台)",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: false
              }
            },
            data: data.offline
          },
          {
            name: "在线(台)",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: false
              }
            },
            data: data.online
          },
          {
            name: "在线率(%)",
            type: "line",
            yAxisIndex: 1,
            label: {
              normal: {
                show: false
              }
            },
            smooth: 0.3,
            itemStyle: {
              normal: {
                color: "#2C89F6"
              }
            },
            data: data.onlineRate
          }
          ]
        });
        window.addEventListener("resize", function () {
          deviceOnline.resize();
        });
      },

      /***网关在线情况echart图****/
      moduleOnline() {
        // 基于准备好的dom，初始化echarts实例
        let moduleOnline = echarts.init(document.getElementById("moduleOnline"));
        moduleOnline.clear();
        var data = this.moduleOnlineData;
        moduleOnline.setOption({
          color: ["#D8D8D8", "#5BAD23"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ["在线", "离线"],
            x: "60px"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: data.time
          },
          yAxis: [{
            name: '网关数(台)',
            type: 'value',
          },
          {
            name: '在线率(%)',
            max: 100,
            type: 'value',
          }
          ],
          series: [{
            name: "离线(台)",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: false
              }
            },
            data: data.offline
          },
          {
            name: "在线(台)",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: false
              }
            },
            data: data.online
          },
          {
            name: "在线率(%)",
            type: "line",
            yAxisIndex: 1,
            label: {
              normal: {
                show: false
              }
            },
            smooth: 0.3,
            itemStyle: {
              normal: {
                color: "#FF8B9F"
              }
            },
            data: data.onlineRate
          }
          ]
        });
        window.addEventListener("resize", function () {
          moduleOnline.resize();
        });
      },

      /***api调用统计echart图****/
      apiVisitStatisticsEchart() {
        // 基于准备好的dom，初始化echarts实例
        let apiVisitStatistics = echarts.init(document.getElementById("apiVisitStatistics"));
        apiVisitStatistics.clear()
        var data = this.apiVisitStatisticsData;
        var sType = this.statisticalType;
        apiVisitStatistics.setOption({
          color: ["#38A2FF", "#5BAD23", "#F56C6C"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line" // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: sType == 'number' ? ["调用总次数", "成功次数", "失败次数"] : ["调用总耗时", "平均耗时", "最大耗时"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: data.dateList
          },
          yAxis: [{
            name: sType == 'number' ? "调用次数（次）" : "调用耗时（ms）",
            type: 'value',
          }],
          series: [{
            name: sType == 'number' ? "调用总次数" : "调用总耗时",
            type: "line",
            label: {
              normal: {
                show: false
              }
            },
            smooth: 0.3,
            itemStyle: {
              normal: {
                color: "#38A2FF"
              }
            },
            data: sType == 'number' ? data.visitCountList : data.sumConsumeMillisecondsList
          },
          {
            name: sType == 'number' ? "成功次数" : "平均耗时",
            type: "line",
            label: {
              normal: {
                show: false
              }
            },
            smooth: 0.3,
            itemStyle: {
              normal: {
                color: "#5BAD23"
              }
            },
            data: sType == 'number' ? data.successCountList : data.avgConsumeMillisecondsList
          },
          {
            name: sType == 'number' ? "失败次数" : "最大耗时",
            type: "line",
            label: {
              normal: {
                show: false
              }
            },
            smooth: 0.3,
            itemStyle: {
              normal: {
                color: "#F56C6C"
              }
            },
            data: sType == 'number' ? data.errorCountList : data.maxConsumeMillisecondsList
          }
          ]
        });
        window.addEventListener("resize", function () {
          apiVisitStatistics.resize();
        });
      },

      /***分类统计饼图****/
      commuTypeStatisticsEchart(countName, data) {
        //countName：dev为设备分类饼图，mdu为网关分类饼图
        var el = countName == 'dev' ? 'devCommuTypeCount' : 'mduCommuTypeCount'
        // 基于准备好的dom，初始化echarts实例
        let commuTypeStatistics = echarts.init(document.getElementById(el));
        for (var i in data) {
          data[i].value = data[i].commuTypeCount;
          switch (data[i].commuType) {
            case 1:
              data[i].name = 'TCP';
              break
            case 2:
              data[i].name = 'UDP';
              break
            case 3:
              data[i].name = 'MQTT';
              break
            case 4:
              data[i].name = 'HTTP';
              break
            case 5:
              data[i].name = 'COAP';
              break
          }
        }
        commuTypeStatistics.setOption({
          color: ["#38A2FF", "#5BAD23", "#F56C6C", "#E6A23C", "#EE7AE9"],
          tooltip: {
            trigger: "item",
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['TCP', 'UDP', 'MQTT', 'HTTP', 'COAP']
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          series: [{
            name: (countName == 'dev' ? '设备' : '网关') + '类型统计',
            type: 'pie',
            radius: '55%',
            center: ['60%', '60%'],
            data: data,
            animation: true,
            animationEasing: "quadraticInOut",
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        });
        window.addEventListener("resize", function () {
          commuTypeStatistics.resize();
        });
      },
      /*********************时间变化触发************************/
      //设备情况时间选择器变化
      changeDeviceDate() {
        this.openDeviceDate = '';
        this.getDeviceOnlineData();
      },
      //设备情况时间快速选择
      selectDeviceDate() {
        if ('week' == this.openDeviceDate) {
          this.deviceDate = [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7), new Date()]
        }
        if ('month' == this.openDeviceDate) {
          this.deviceDate = [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 30), new Date()]
        }
        this.getDeviceOnlineData();
      },

      //网关情况时间选择器变化
      changeModuleDate() {
        this.openModuleDate = '';
        this.getModuleOnlineData();
      },
      //网关情况时间快速选择
      selectModuleDate() {
        if ('week' == this.openModuleDate) {
          this.moduleDate = [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7), new Date()]
        }
        if ('month' == this.openModuleDate) {
          this.moduleDate = [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 30), new Date()]
        }
        this.getModuleOnlineData();
      },
    },
    mounted() {
      this.init();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/dashboard.vue